




















import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import { ProductLabelColor } from '~/types/common';

export default defineComponent({
  props: {
    color: {
      type: String as PropType<ProductLabelColor>,
      required: true,
    },
    point: {
      type: Number,
      required: true,
    },
    labels: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props) {
    // 商品詳細画面で色のクラス名が直接返されるため、デフォルトでprops.colorを返しています
    const bgColor = computed(() => {
      switch (props.color) {
        case 'WineRed':
          return 'bg-WineRed';
        case 'WineWhite':
          return 'bg-WineWhite';
        case 'WineRose':
          return 'bg-WineRose';
        case 'WineOrange':
          return 'bg-WineOrange';
        case 'WineSparkling':
          return 'bg-WineSparkling';
        case 'WineSweet':
          return 'bg-WineSweet';
        default:
          return props.color;
      }
    });
    /**
     * バーのポイントの位置を返す
     * 甘口は3段階、ボディは5段階のため、それぞれを等分にすることで位置が決まる
     */
    const pointCirclePosition = computed(() => {
      if (props.color === 'WineSweet') {
        switch (props.point) {
          case 1:
            return 'left-0';
          case 2:
            return 'right-[47%]';
          case 3:
            return 'right-0';
        }
      }
      switch (props.point) {
        case 1:
          return 'right-full';
        case 2:
          return 'right-[73.5%]';
        case 3:
          return 'right-[47%]';
        case 4:
          return 'right-[22.5%]';
        case 5:
          return 'right-0';
      }
    });
    return {
      bgColor,
      pointCirclePosition,
    };
  },
});
